<template>
	<div class="row my-4">
		<div class="col-sm-12 position-relative border border-warning py-2">
			<div class="row">
				<div class="form-group col-sm-6">
					<BaseMultiSelect
						@update:value="setCountry"
						:options="multiSelectState.countriesSelect"
						rules="required"
						name="Country"
						mode="single"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>

				<div class="from-group col-sm-4">
					<BaseInput
						name="Amount"
						label="Amount"
						type="number"
						:min="50"
						v-model="data.amount"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
			</div>
			<span
				v-if="count !== 0"
				@click="$emit('removeComponent', count)"
				class="mx-2 position-absolute top-100 start-100 translate-middle badge rounded-pill bg-danger cursor-pointer"
				><i class="bi bi-x"></i
			></span>
		</div>
	</div>
</template>
<script>
	import { reactive, watch } from "vue";
	import Helper from "@/helpers/dataHelper";

	import BaseInput from "./BaseInput";
	import BaseMultiSelect from "./BaseMultiSelect";

	export default {
		name: "LeadForex",
		components: {
			BaseInput,
			BaseMultiSelect,
		},
		props: {
			count: { type: Number, default: 0 },
		},
		emits: ["removeComponent", "updateData"],
		setup: (props, { emit }) => {
			const data = reactive({
				country: {
					id: 0,
					name: null,
				},
				amount: null,
			});

			watch(
				() => data,
				(preValue, newValue) => {
					if (data.country.name && data.amount) {
						emit("updateData", { index: props.count, data });
					}
				},
				{ deep: true },
			);

			const multiSelectState = reactive({
				countries: [],
				countriesSelect: [],
			});

			// ! Country Functions
			const getCountries = async () => {
				try {
					const response = await Helper.getCountries();
					const countries = response;
					multiSelectState.countries = countries;
					multiSelectState.countriesSelect = countries.map((country) => {
						return { label: country.name, value: country.id };
					});
				} catch (error) {
					console.log(error);
				}
			};
			getCountries();

			const setCountry = (dataObj) => {
				if (!dataObj) {
					data.country.id = 0;
					data.country.name = null;
					return;
				}
				// ? finding selected city data
				const country = multiSelectState.countries.filter(
					(country) => country.id === dataObj,
				);
				data.country.id = country[0].id;
				data.country.name = country[0].name;
			};

			const inputError = (input) => {};
			const inputSuccess = (input) => {};

			return {
				data,
				multiSelectState,

				setCountry,

				inputError,
				inputSuccess,
			};
		},
	};
</script>
